


export const barChartDataWeeklyRevenue = [
  {
    name: "Weekly Token ",
    data: [
      { x: new Date("2025-07-01").getTime(), y: 30 },
      { x: new Date("2025-07-02").getTime(), y: 45 },
      { x: new Date("2025-07-03").getTime(), y: 60 },
      { x: new Date("2025-07-04").getTime(), y: 25 },
      { x: new Date("2025-07-05").getTime(), y: 80 },
      { x: new Date("2025-07-06").getTime(), y: 50 },
      { x: new Date("2025-07-07").getTime(), y: 70 },
    ],
    color: "#4318FF",
  },
];

export const barChartOptionsWeeklyRevenue = {
  yaxis: {
    show: true,
    max: 100,
    min: 0,
    tickAmount: 4,
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
      formatter: function (value) {
        return value.toFixed(0);
      },
    },
  },
  chart: {
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    theme: 'light',
    style: {
      fontSize: "14px",
      fontFamily: "Figtree, sans-serif",
    },
    x: {
      format: 'dd MMM',
    },
  },
  xaxis: {
    type: 'datetime',
    tickAmount: 5,
    labels: {
      show: true,
      format: 'dd MMM',
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "400",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },

  grid: {
    show: true,
    borderColor: '#e0e0e0',
    strokeDashArray: 5,
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  legend: {
    show: false,
  },
  colors: ["#2563eb"],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      columnWidth: "30px",
    },
  },
};
